var AbstractViewModel = require("./AbstractViewModel")

/**
 * @constructor CustomPropertyInputViewModel
 * @param {CustomScreenFieldModel} customScreenField
 * @param {AbstractViewModel} container
 */
function CustomFieldInput(customScreenField, initialValue, container) {
  var self = this;

  AbstractViewModel.apply(this, [container])

  this.customScreenField = customScreenField;
  this.container = container; // you may also use `this.parent`

  /**
   * The original value from the API or `null`
   * @type {KnockoutObservable}
   */
  this.initialValue = ko.observable((initialValue) ? initialValue : null)

  /**
   * The value input by the Employee
   * @type {KnockoutObservable}
   */
  this.fieldValue = ko.observable(null)

  /**
   * If the field's value was not set or not modified, it returns the original value.
   * 
   * @function value
   */
  this.value = ko.computed({
    read: function () {
      return (this.fieldValue() !== null) ? this.fieldValue() : this.initialValue()
    }, 
    write: function (value) {
      this.fieldValue(value)
      this.dirty()
    },
    owner: this
  })

  /**
   * Indicates whether the field has bend modified
   */
  this.isDirty = ko.observable(false)

  // To support checkbox fields
  this.isChecked = ko.observable()

  this.validationResult = ko.observable(null)

  this.name = function () {
    return this.customScreenField.name
  }

  this.id = function() {
    return this.customScreenField.id
  }

  this.inputMask = function () {
    return this.customScreenField.inputMask
  }

  // This flag is set externally
  this.inputMaskValid = ko.observable(null)

  /**
   * Indicated if the input value failed Linebuster's Custom Prop validation
   * (not in whitelist or external validation failed)
   * @type {KnockoutObservable<string>}
   */
  this.serverValidationError = ko.observable()

  this.dirty = function () {
    self.isDirty(this.initialValue() != this.value())
  }

  this.clean = function () {
    self.fieldValue(null)
    self.isDirty(false)
  }

  this.label = ko.deferredComputed(function () {
    return this.customScreenField.label()
  }, this)

  this.attr = ko.deferredComputed(this._attr, this)
  this.labelAttr = ko.deferredComputed(this._labelAttr, this)

  /**
   * Is this field a text/number field?
   */
  this.isTextual = ko.deferredComputed(function () {
    return this.customScreenField.isTextual()
  }, this)

  /**
   * Should this field be rendered as an `<input>` element?
   * @returns boolean
   */
  this.isInputElement = ko.deferredComputed(function () {
    return this.customScreenField.isInputElement()
  }, this)

  this.isSelectElement = ko.deferredComputed(function () {
    return this.customScreenField.isSelectElement()
  }, this)

  this.isText = ko.deferredComputed(function () {
    return this.customScreenField.isText()
  }, this)

  this.isNumber = ko.deferredComputed(function () {
    return this.customScreenField.isNumber()
  }, this)

  this.isCheckbox = ko.deferredComputed(function () {
    return this.customScreenField.isCheckbox()
  }, this)

  this.isInvalid = ko.deferredComputed(function () {
    var result = this.validationResult()
    return (result && result.valid === false)
  }, this)

  this.isValid = ko.deferredComputed(function () {
    var result = this.validationResult()
    return (result && result.valid === true)
  }, this)

  this.invalidReason = ko.deferredComputed(function () {
    var result = this.validationResult()
    return (result && result.reason) ? result.reason : null
  }, this)

  this.isInvalidByServer = ko.deferredComputed(function () {
    var error = this.serverValidationError()
    return error !== null || error !== ""
  }, this)

  this.isDirty = ko.observable(false)

  this.isEmpty =  ko.deferredComputed(function () {
    var value = this.value()
    return this.customScreenField.isEmptyValue(value)
  }, this)

  /**
   * The kind of custom field
   * 
   * @type {KnockoutComputed}
   */
  this.type = ko.deferredComputed(function () {
    return this.customScreenField.type
  }, this)

  /**
   * Whether field is required or not 
   * 
   * @type {KnockoutComputed}
   */
  this.isRequired = ko.deferredComputed(function () {
    return this.customScreenField.required || this.customScreenField.optionsHaveQueueIds()
  }, this)


  this.options = ko.deferredComputed(function () {
    return this.customScreenField.options()
  }, this)
  
  /**
   * Validate the Custom Property value
   */
  this.validate = function() {

    var value = this.value()

    var result = this.customScreenField.validate(value)

    if (result.valid === true) {
      var inputMaskInvalid = (this.inputMaskValid() === false)
      if (inputMaskInvalid) {
        result = {
          valid: false,
          reason: this.customScreenField.INVALID_PATTERN
        }
      }
    }

    this.validationResult(result)
  }

  this.handleChange = function(data, event) {
  }.bind(this)

  /**
   * Validate the custom property value using the CustomScreenField's rules/configuration.
   */
  this.handleValidate = function(data, event) {
    this.validate()
  }.bind(this)
}

CustomFieldInput.prototype = Object.create(AbstractViewModel.prototype)
CustomFieldInput.prototype.constructor = CustomFieldInput

CustomFieldInput.prototype.ELEMENT_NAME_PREFIX = "customField_"

CustomFieldInput.prototype.elementName = function () {
  return this.ELEMENT_NAME_PREFIX + this.customScreenField.name
}

CustomFieldInput.prototype._attr = function() {
  var isTextual = this.customScreenField.isTextual()
  var isInvalid = this.isInvalid()
  var classes = []

  if (isTextual) {
    classes.push("input-hinted")
  }

  if (isInvalid) {
    classes.push("invalid")
  }
  
  if (this.isDirty()) {
    classes.push("dirty")
  }

  var attrs = {
    name: this.elementName(),
    id: this.elementName(),
    required: this.customScreenField.required,
    class: classes.join(" ")
  }

  if (this.customScreenField.fieldLength) {
    attrs["maxLength"] = this.customScreenField.fieldLength
  }

  return attrs
}

CustomFieldInput.prototype._labelAttr = function () {
  return {
    for: this.elementName()
  }
}

module.exports = CustomFieldInput
